import React from 'react';
import './BlogPagination.scss';
import SvgIcons from '../../../../services/SvgIcons';

const BlogPagination = ({ currentPage, totalPages, onPageChange }) => {
    if (totalPages <= 1) return null;

    // Calculer les pages à afficher
    const getVisiblePages = () => {
        const pages = [];
        const showPages = 5; // Nombre de pages visibles
        
        let startPage = Math.max(1, currentPage - Math.floor(showPages / 2));
        let endPage = Math.min(totalPages, startPage + showPages - 1);
        
        // Ajuster le début si on est proche de la fin
        if (endPage - startPage < showPages - 1) {
            startPage = Math.max(1, endPage - showPages + 1);
        }
        
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        
        return pages;
    };

    const visiblePages = getVisiblePages();

    return (
        <nav className="blog-pagination" aria-label="Navigation du blog">
            <div className="blog-pagination__container">
                {/* Bouton Précédent */}
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage <= 1}
                    className="blog-pagination__button blog-pagination__prev"
                    aria-label="Page précédente"
                >
                    <SvgIcons
                        name="chevron_back"
                        width={20}
                        height={20}
                        color="#361215"
                        marginRight="5px"
                    />
                    <span>Précédent</span>
                </button>

                {/* Pages */}
                <div className="blog-pagination__pages">
                    {/* Première page si pas visible */}
                    {visiblePages[0] > 1 && (
                        <>
                            <button
                                onClick={() => onPageChange(1)}
                                className="blog-pagination__page"
                                aria-label="Page 1"
                            >
                                1
                            </button>
                            {visiblePages[0] > 2 && (
                                <span className="blog-pagination__ellipsis">...</span>
                            )}
                        </>
                    )}

                    {/* Pages visibles */}
                    {visiblePages.map(page => (
                        <button
                            key={page}
                            onClick={() => onPageChange(page)}
                            className={`blog-pagination__page ${
                                page === currentPage ? 'blog-pagination__page--active' : ''
                            }`}
                            aria-label={`Page ${page}`}
                            aria-current={page === currentPage ? 'page' : undefined}
                        >
                            {page}
                        </button>
                    ))}

                    {/* Dernière page si pas visible */}
                    {visiblePages[visiblePages.length - 1] < totalPages && (
                        <>
                            {visiblePages[visiblePages.length - 1] < totalPages - 1 && (
                                <span className="blog-pagination__ellipsis">...</span>
                            )}
                            <button
                                onClick={() => onPageChange(totalPages)}
                                className="blog-pagination__page"
                                aria-label={`Page ${totalPages}`}
                            >
                                {totalPages}
                            </button>
                        </>
                    )}
                </div>

                {/* Bouton Suivant */}
                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage >= totalPages}
                    className="blog-pagination__button blog-pagination__next"
                    aria-label="Page suivante"
                >
                    <span>Suivant</span>
                    <SvgIcons
                        name="chevron_back"
                        width={20}
                        height={20}
                        color="#361215"
                        transform="rotate(180deg)"
                        marginLeft="5px"
                    />
                </button>
            </div>

            {/* Information de pagination */}
            <div className="blog-pagination__info">
                Page {currentPage} sur {totalPages}
            </div>
        </nav>
    );
};

export default BlogPagination;